const CryptoJS = require("crypto-js");
/**
 * @Author HS
 * @Date 2021/6/21 2:57 下午
 * @Description: 前端加密
 * @Params: { string : message - true } [message：加密字符]
 * @Return: null
*/
let key = 'fajypx888';
export const encryptBy = (message) => {
    function encryptByDES (message, key) {
        let keyHex = CryptoJS.enc.Utf8.parse(key)
        let option = {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}
        let encrypted = CryptoJS.DES.encrypt(message, keyHex, option)
        return encrypted.ciphertext.toString()
    }
    return encryptByDES(message, key);
}

/**
 * @Author HS
 * @Date 2021/6/21 2:55 下午
 * @Description: 前端解密
 * @Params: { string : afterEncrypt - true } [afterEncrypt：解密字符]
 * @Return: string
 */
export const decryptBy = (message) => {
    //DES  ECB模式解密
    function decryptByDES(message,key){
        let keyHex = CryptoJS.enc.Utf8.parse(key);
        let decrypted = CryptoJS.DES.decrypt({
            ciphertext: CryptoJS.enc.Hex.parse(message)
        }, keyHex, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });
        let result_value = decrypted.toString(CryptoJS.enc.Utf8);
        return result_value;
    }
    return decryptByDES(message, key);
}

/**
 * @Author HS
 * @Date 2021/6/21 2:55 下午
 * @Description: 获取存储数据，并进行解密
 * @Params: { string : name - true } [name：存储参数]
 * @Return: string
 */
export function getDecryptBy(name) {
    const data = window.localStorage.getItem(name)
    if (data == undefined || data == 'undefined' || data == null || data == 'null' || data == ""){
		return `${name}-暂未存储`
    }
    let str = decryptBy(data)
    if(str.indexOf('{') > -1 || str.indexOf('[') > -1){
        return JSON.parse(str)
    }
    return str
}


/**
 * @Author HS
 * @Date 2021/6/21 2:57 下午
 * @Description: 前端加密
 * @Params: { string : message - true } [message：加密字符]
 * @Return: null
*/
let phpkey = CryptoJS.enc.Utf8.parse('0a6b7fb4cff6c74d');
let iv = CryptoJS.enc.Utf8.parse('0a6b7fb4cff6c74d');
export function phpEncrypt(data) {
	let text = JSON.stringify(data);
	text = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text)).toString();
	let encrypted = CryptoJS.AES.encrypt(text, phpkey, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.ZeroPadding
	}).toString();
	return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(encrypted)).toString();
}

export function phpDecrypt(data) {
	let encrypted = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(data)).toString();
	let decrypted = CryptoJS.AES.decrypt(encrypted, phpkey, {
		iv: iv,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.ZeroPadding
	}).toString(CryptoJS.enc.Utf8);
	return CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(decrypted)).toString();
}



